import { gsap, MorphSVGPlugin, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(MorphSVGPlugin)
gsap.registerPlugin(ScrollTrigger)

class FngExternalVideo extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.video = this.querySelector('.video--video');
    this.figure = this.querySelector('.video--figure');

    if (!this.video.hasAttribute('src')) {
      let templateContent = this.querySelector('template').content;
      this.figure.append(templateContent.cloneNode(true));

      this.button = this.querySelector('.button');
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const notification = this.querySelector('.video--notification');
        notification.remove();
        this.video.setAttribute('src', this.video.dataset.src);
      });
    }
  }

}


// Define the new web component
if ('customElements' in window) {
  customElements.define('fng-external-video', FngExternalVideo);
}
